import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';
import { estudiantesApi } from '../estudiantes/EstudiantesService';

export const ASISTENCIAS_DIARIAS_API = 'asistencias_diarias';
export const asistenciasDiariasApi = `${baseUrl}/asistencias-diarias`;

export const allAsistenciasService = async (params) => {
  const res = await axios.get(asistenciasDiariasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveAsistenciasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${asistenciasDiariasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(asistenciasDiariasApi, data, { headers: token({}) });
  }
  return res;
};

export const allEstudiantesAsistenciasService = async (params) => {
  const res = await axios.get(`${estudiantesApi}/${ASISTENCIAS_DIARIAS_API}`, {
    headers: token({}),
    params,
  });
  return res;
};
